import { createFeatureSelector } from '@ngrx/store';
import { CardBatchesSearchState } from '../models/card-batches.model';
import { SchemasCreateNewState, SearchState } from '../models/schemas.model';
import { CardBatchesReducer } from './card-batches.reducer';
import { SchemasCreateNewReducer } from './create-new.reducer';
import { SchemasSearchReducer } from './search.reducer';

export const featureSchemasName = 'Schemas';

export interface DragonflySchemasState {
  search: SearchState;
  createNew: SchemasCreateNewState;
  cardBatches: CardBatchesSearchState;
}

export const moduleSchemasReducers = {
  search: SchemasSearchReducer,
  createNew: SchemasCreateNewReducer,
  cardBatches: CardBatchesReducer,
};

export const getDragonflySchemasState = createFeatureSelector<DragonflySchemasState>(featureSchemasName);
